import React, {useState} from "react";
import { projectState } from '../Imports/project';
import '../CSS/project.scss';
import ProjectCard from "./ProjectCard";
import ProjectFilter from "./ProjectFilter";
import {motion, AnimatePresence} from 'framer-motion'
import { pageAnimation } from "../Variants/variants";

const Projects = ({previewGif, setPreviewGif, previewHover, setPreviewHover}) => {
    const [projects, setProjects] = useState(projectState);
    const [filtered, setFiltered] = useState([]);
    const [activeButton, setActiveButton] = useState("All");

    return(
        <motion.div 
        className="project-container" 
        variants={pageAnimation}
        initial="initial"
        animate="animate"
        exit="exit">
            <ProjectFilter 
            projects={projects} 
            setFiltered={setFiltered}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            previewGif={previewGif}
            previewHover={previewHover}
            setPreviewGif={setPreviewGif}
            setPreviewHover={setPreviewHover}/>
            
            <motion.div className="project-list-container">
            <AnimatePresence>
                {filtered.map((project, index) =>{
                    return(
                        <ProjectCard 
                        project={project} 
                        key={index}
                        previewGif={previewGif}
                        previewHover={previewHover}/>
                    )
                })}
                </AnimatePresence>
            </motion.div>
        </motion.div>
    )
}

export default Projects;